<div [ngClass]="{'overdue-job':isOverdueJob}" *ngIf="displayingValue">
    <mat-card class="progress-card">
        <div class="d-flex align-items-center justify-content-start bar" [ngStyle]="{'width':progressPercentage}">
            <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Example notifications icon"
                outline>
                notifications
            </mat-icon>
            <div class="d-flex align-items-center progress-field">{{description || 'Deadline'}}: &nbsp;
                <span class="text-dark"> {{(isValidDate(displayingValue)? (displayingValue | ordinalDate) : displayingValue)}}</span>
            </div>
        </div>
    </mat-card>
</div>